import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';

const showPricing = (app) => {
  return !app.hidePricing;
};

const hasPremiumPackage = (app) => {
  return app.hasPremium && app.packages[0].is_active;
};

const showBasePackage = (app) => {
  return app.hasFree && !app.premiumOnly;
};

const showPremiumPackage = (app) => {
  return hasPremiumPackage(app) && !app.externalPremium;
};

const showExternalPremiumPackage = (app) => {
  return app.externalPremium;
};

const getActivePackages = (app) => {
  return app.packages.filter(p => p.is_active);
};

const hasMultiplePackages = (app) => {
  return getActivePackages(app).length > 1;
};

const hasMultipleCycles = (app) => {
  return getActivePackages(app).filter(pkg => pkg.monthly.price && pkg.yearly.price).length > 0;
};

const getLowestPrice = (app) => {
  const prices = _.transform(getActivePackages(app), (result, pkg) => {
    result.push.apply(result, [pkg.monthly.price, pkg.yearly.price].filter(i => i));
  }, []);

  return _.sortBy(prices.filter((p) => parseInt(p) !== 0), (p) => parseFloat(p)).shift();
};

const getPriceString = (app) => {
  const prices = [parseFloat(app.price.monthlyPriceValue), parseFloat(app.price.yearlyPriceValue)].filter(i => i > 0);
  const priceB = getLowestPrice(app);

  if (prices.length) {
    return `${Math.min(...prices).toFixed(2)} ${app.price.currencyCode}`;
  } else if (priceB) {
    return `${parseFloat(priceB).toFixed(2)} USD`;
  } else {
    return '';
  }
};

export default class AppFeatures extends React.Component {

  render() {
    const app = this.props.app;
    const state = this.state || {activeKey: 0};

    const premiumPriceTrans = (hasMultiplePackages(app) || hasMultipleCycles(app)) ? 'application.price.startsFrom' : 'application.price.perMonth';
    const premiumPriceVal = getPriceString(app);

    return (
      <div className="app-tab-features">
        <div className="head">
          <table className="title-container">
            <tbody>
              <tr>
                <td className="title-main"><h3 className="typography_t2"><FormattedMessage id="application.tabs.features.featureTitle"/></h3></td>

                {showBasePackage(app) ?
                  <td className="title-package package-base">
                    <h4 className="typography_t4"><FormattedMessage id="application.tabs.features.basePackage"/></h4>
                    <p className="package-price"><FormattedMessage id="application.price.free"/></p>
                  </td> : null}

                {showPremiumPackage(app) ?
                  <td className="title-package package-premium">
                    <h4 className="typography_t4"><FormattedMessage id="application.price.premium"/></h4>
                    {showPricing(app) ?
                      <p className="package-price"><FormattedMessage id={premiumPriceTrans} values={{price: premiumPriceVal}}/></p> : ''}
                  </td> : null }

                {showExternalPremiumPackage(app) ?
                  <td className="title-package package-external-premium">
                    <h4 className="typography_t4"><FormattedMessage id="application.price.premium"/></h4>
                  </td> : null}
              </tr>
            </tbody>
          </table>
        </div>

        <div className="body">
          <table className="feature-table">
            <tbody>
              {app.features.map((feature, key) =>
                <tr key={key} className={classNames('feature-row', {'active': state.activeKey === key})} onClick={() => this.setState({activeKey: key})}>
                  <td className="spacing">&nbsp;</td>
                  <td className="feature-data">
                    <div>
                      <h4 className={classNames('feature-title typography_t2', {'active': state.activeKey === key})}>{feature.title}</h4>
                      {state.activeKey === key ? <p className="feature-description typography_t4_1">{feature.featureDescription || feature.description }</p> : ''}
                    </div>
                  </td>

                  {showBasePackage(app) ?
                    <td className={classNames('feature-package package-free typography_t4', {'checked': feature.free && !feature.freeText, 'last': !showPremiumPackage(app) && !showExternalPremiumPackage(app)})}>
                      {feature.freeText}
                    </td> : null }

                  {showPremiumPackage(app) ?
                    <td className={classNames('feature-package package-premium last typography_t4', {'checked': feature.premium && !feature.premiumText})}>
                      {feature.premiumText}
                    </td> : null }

                  {showExternalPremiumPackage(app) ?
                    <td className={classNames('feature-package package-external-premium last typography_t4', {'checked': feature.premium && !feature.premiumText})}>
                      {feature.premiumText}
                    </td> : null }

                  <td className="spacing">&nbsp;</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

AppFeatures.propTypes = {
  app: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./components/App-features.js